import { useCallback } from 'react'

import { Translation, useSafetyTranslation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { NotificationController } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../configs/translations'

import { useCockpitExport } from './CockpitExportProvider'

import styles from './CockpitExportButton.module.scss'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.export

/** Downloads the expanded tile as a slide. Renders nothing for a tile that offers no export,
 *  so a tile gains the button by registering one — see `CockpitExportProvider`. */
export const CockpitExportButton = () => {
  const t = useSafetyTranslation()
  const { canExport, isExporting, exportTile } = useCockpitExport()

  const handleClick = useCallback(async () => {
    const isExported = await exportTile()

    if (!isExported) {
      NotificationController.showError({ message: t(KEYS.error) })
    }
  }, [exportTile, t])

  if (!canExport) {
    return null
  }

  return (
    <Tooltip inline tipContent={() => <Translation span text={KEYS.tooltip} />}>
      <Button
        className={styles.root}
        variant="text"
        size="sm"
        iconButton="kbase kbase-ppt"
        loading={isExporting}
        disabled={isExporting}
        onClick={handleClick}
      />
    </Tooltip>
  )
}

CockpitExportButton.displayName = 'CockpitExportButton'
